<script setup lang='ts' name = 'Company'>
import { useFormStore } from '@/stores/form'
const formStore = useFormStore()

function gologin(){
    formStore.switchForm('login')
}
</script>

<template>
    <div class="Companycontainer">
    <h1>關於虔智科技</h1>
    <p><strong>虔智科技</strong>成立於 2007年，是一間專精於軟體韌體系統整合致力於將創新科技與智慧應用深度結合，為企業與社會帶來更高效、更智慧的解決方案。我們專注於人工智慧、大數據分析、物聯網（IoT）以及自動化技術的整合開發，為各產業提供量身打造的數位轉型服務。</p>

    <p>我們的團隊由一群擁有豐富經驗的工程師與開發專家組成，秉持著「專業、創新、誠信」的理念，持續追求卓越。我們相信科技不只是工具，而是推動未來的力量。虔智科技協助客戶從需求出發，規劃並打造可落地、可擴展的解決方案，協助企業掌握市場先機、創造長遠價值。</p>

    <h2>我們的使命</h2>
    <p>以科技創新為核心，提供智慧化、高效率的解決方案，協助客戶實現數位升級與產業革新。</p>

    <h2>我們的願景</h2>
    <p>成為領先的智慧科技整合服務商，與客戶共同打造更智慧、更永續的未來。</p>

    <h2>服務領域</h2>    
    <p>
      虔智科技提供全面的技術解決方案，涵蓋工業自動化與 IoT 整合、客製化軟體開發、系統整合與技術顧問服務。我們具備軟體、韌體與硬體的全方位研發能力，從企業內部管理系統到行動應用，打造穩定、高效且量身訂做的系統架構。
      在嵌入式與感測控制方面，支援多種 MCU 平台，並可提供從原理圖設計、PCB Layout 到硬體整合的完整設計流程。
      此外，我們也具備 3D 模型設計能力，協助客戶從產品構想到外觀建模與快速打樣，縮短開發時程。
      團隊亦專精於人工智慧與機器學習技術，結合數據分析，協助企業實現智慧決策、自動化流程與預測性管理，為企業創造數位轉型的新價值。
    </p>


    <p><strong>虔智科技，不只是科技的提供者，更是您邁向未來的合作策略夥伴。</strong></p>
    <button @click="gologin">返回</button>
  </div>
</template>

<style>
.Companycontainer{
    padding: 20px;
            border-radius: 10px;
            width: 80%; /* 調整寬度為 80% */
            max-width: 600px; /* 設定最大寬度為 800px */
            margin: 0 auto; /* 居中對齊 */
            
    
}
button {
  margin: 15px 0;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 20px;
  background-color: deeppink;
  width: 400px;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  align-self: center;
}
button:hover {
  transform: scale(1.04);
}
h1, h2 {
            color: deeppink
        }
        h1 {
            font-size: 2.5em;
            margin-bottom: 20px;
            
        }
        h2 {
            font-size: 1.5em;
            margin-top: 20px;
            margin-bottom: 10px;
            
        }
        p, ul {
            font-size: 1.1em;
            line-height: 1.6;
            margin: 10px 0;
        }
        ul {
            list-style-type: none;
            padding: 0;
        }
        li {
            margin: 5px 0;
        }


</style>